import React from 'react';
import { usePhone } from '../../hooks/use-phone';
import { usePhoneWarnings } from '../../hooks/use-phone/use-phone-warning';
import CallErrorNoMicPermissions from './call-error-no-mic-permissions';
import CallErrorNoMicrophone from './call-error-no-microphone';
import CallErrorNotCreated from './call-error-not-created';
import CallErrorPbxNotConfigured from './call-error-pbx-not-configured';
import CallErrorPhoneInUse from './call-error-phone-in-use';
import CallWarningTryAgain from './call-warning-try-again';

export interface IProps { 
    hasCallPops?: boolean
    hasScreenPops?: boolean
}

export const CallWarnings: React.FC<IProps> = ({ hasCallPops, hasScreenPops }) => {
    const { warning: error, showWarning } = usePhoneWarnings();
    const { deviceControl: { deviceStatus }} = usePhone();

    if (!showWarning) return null

    if (error === 'device-in-use')  return <CallErrorPhoneInUse />

    if (error === 'notcreated') return <CallErrorNotCreated />

    if (error === 'notconfigured') return <CallErrorPbxNotConfigured />

    if (error === 'nomicrophone') return <CallErrorNoMicrophone />

    if (error === 'nomicpermissions') return <CallErrorNoMicPermissions />

    if (deviceStatus === 'ready' && !hasCallPops && !hasScreenPops) return <CallWarningTryAgain />

    return null;
}

export default CallWarnings 